import { WorkItem } from './interfaces/workitem-base.interface';

let instance: WorkItemPool = null;

export class WorkItemPool {
  readonly _workItemPool = new Map<string, WorkItem>();

  static getInstance(): WorkItemPool {
    if (!instance) {
      instance = new WorkItemPool();
    }

    return instance;
  }

  constructor() {
    if (!instance) {
      instance = this;
    }

    return instance;
  }

  resetPool(): void {
    this._workItemPool.clear();
  }

  getWorkItemById(workItemId?: string): WorkItem | null {
    if (!workItemId) {
      return null;
    }

    return this._workItemPool.get(workItemId);
  }

  getPoolSize(): number {
    return this._workItemPool.size;
  }

  addWorkItem(workItem: WorkItem): void {
    if (!this._workItemPool.has(workItem.id)) {
      this._workItemPool.set(workItem.id, workItem);
    }
  }

  removeWorkItemById(workItemId?: string): void {
    if (!workItemId) {
      return;
    }

    this._workItemPool.delete(workItemId);
  }
}
